import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoInstalacion/addTipoInstalacion`, method: 'POST', body: values, token: token})
}
